import { Dialog } from "@hubertai/hubert-component-library";
import { ArrowDown, X } from "lucide-react";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Heading, TabSelector, Text } from "../../../elements";
import PossibleOutcomes from "./PossibleOutcomes";
import RecruitmentProcess from "./RecruitmentProcess";

const HowHubertScoreModal = () => {
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useState("possibleOutcomes");

    const scrollRef = useRef<HTMLDivElement>(null);
    const [showScrollArrow, setShowScrollArrow] = useState(true);

    const tabs = [
        {
            textKey: "Interview.HowHubertScoresInterviews.Tabs_PossibleOutcomes",
            value: "possibleOutcomes",
        },
        {
            textKey: "Interview.HowHubertScoresInterviews.Tabs_RecruitmentProcess",
            value: "recruitmentProcess",
        },
    ];

    const checkScroll = () => {
        const el = scrollRef.current;
        if (!el) return;

        if (el.scrollHeight <= el.clientHeight) {
            setShowScrollArrow(false);
            return;
        }

        const isAtBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 10;
        setShowScrollArrow(!isAtBottom);
    };

    const handleScrollDown = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ top: 300, behavior: "smooth" });
        }
    };

    return (
        <Dialog.Root>
            <Dialog.Trigger>
                <Button className="mobile-text-sm mt-8">{t("Interview.MyResult.ButtonText_LearnMore")}</Button>
            </Dialog.Trigger>

            <Dialog.Content className="modal-wrapper large how-hubert-scores-modal-popup max-w-[calc(100vw-60px)]!">
                <Dialog.Close>
                    <X className="close-icon" />
                </Dialog.Close>

                {/* Floating Scroll CTA */}
                <div className={`scroll-cta-wrapper ${showScrollArrow ? "" : "hidden"}`}>
                    <button onClick={handleScrollDown} className="scroll-btn">
                        <ArrowDown size={24} />
                    </button>
                </div>

                {/* Scrollable Content Container */}
                <div className="modal-scroll-container" ref={scrollRef} onScroll={checkScroll}>
                    <Heading level="h3" light className="mb-6 text-center">
                        {t("Interview.HowHubertScoresInterviews.Title")}
                    </Heading>

                    <Text>{t("Interview.HowHubertScoresInterviews.Description")}</Text>

                    <TabSelector tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />

                    {selectedTab === "possibleOutcomes" ? <PossibleOutcomes /> : <RecruitmentProcess />}

                    <div className="mt-12 text-center">
                        <Dialog.Close>
                            <Button secondary>{t("Interview.HowHubertScoresInterviews.ButtonText_Close")}</Button>
                        </Dialog.Close>
                    </div>
                </div>
            </Dialog.Content>
        </Dialog.Root>
    );
};

export default HowHubertScoreModal;
